import { Oval } from "react-loader-spinner";

export type SpinnerTemplateProps = { size?: number };

export const SpinnerTemplate = ({
  size,
}: SpinnerTemplateProps): JSX.Element => {
  return <Oval color="#000000" height={size} width={size} />;
};
